function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b0ffa14a\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!./styles.styl")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./script.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b0ffa14a\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./component.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b0ffa14a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/day/component.vue
// module id = e639ccce3bf24e6de47d
// module chunks = 13